export var LogbookDutyMode;
(function (LogbookDutyMode) {
    LogbookDutyMode["commercial"] = "commercial";
    LogbookDutyMode["nonCommercial"] = "non-commercial";
    LogbookDutyMode["sport"] = "sport";
})(LogbookDutyMode || (LogbookDutyMode = {}));
//# sourceMappingURL=LogbookCustomData.js.map